// extracted by mini-css-extract-plugin
module.exports = {"hidden":"_1iQ18","textGroup":"_3eec2","noranlText":"_3GF6C","fade":"_36RaJ","slideup":"_3fVLg"};